import { type Node } from "prosemirror-model";
import { useMemo } from "react";

import { schema } from "@moment/prosemirror-schema";
import { useEditorStateForCurrRoute } from "@moment/state";

export const useEaselSelectedComputeCellNodes = () => {
	const { editorState } = useEditorStateForCurrRoute();
	return useMemo(() => {
		const nodes: Node[] = [];

		const selection = editorState?.selection;
		if (!selection) {
			return nodes;
		}

		editorState.doc.nodesBetween(selection.from, selection.to, (node) => {
			if (!node.attrs["id"] || node.type !== schema.nodes.compute_cell) {
				return true;
			}
			nodes.push(node);
			return true;
		});

		return nodes;
	}, [editorState]);
};
